import * as React from 'react';

import type { SanityFaqSection } from '#/lib/sanity/queries/sections';

import { BasicText } from './BasicText';
import { FaqAccordion } from './FaqAccordion';

type InlineFaqProps = {
  questions: SanityFaqSection['questions'];
};

export function InlineFaq({ questions }: InlineFaqProps) {
  return (
    <FaqAccordion
      questions={questions}
      renderAnswer={(answer) => <BasicText value={answer} />}
    />
  );
}
